import * as AdminConstants from '../constants/admin-constants';
import API from '../api/admin-api';

const fetchAllUsersBegin = () => {
    return {
        type: AdminConstants.FETCH_USERS_BEGIN
    }
}

const fetchAllUsersSuccess = (data) => {
    return {
        type: AdminConstants.FETCH_USERS_SUCCESS,
        data
    }
}

const fetchAllUsersError = (error) => {
    return {
        type: AdminConstants.FETCH_USERS_FAILURE,
        error
    }
}

export const getAllUsers = () => (dispatch) => {
    dispatch(fetchAllUsersBegin());
    API.getAllUsers()
        .then((response) => {
            if (response.data.errorMessage) {
                dispatch(fetchAllUsersError(response.data));
            }
            if (response.data) {
                    dispatch(fetchAllUsersSuccess(response.data));
                
            }
        })
        .catch((err) => {
            dispatch(fetchAllUsersError(err));
        });
}

//Actions for get admin reports
const fetchReportBegin = (data) => {
    return {
        type: AdminConstants.FETCH_REPORT_BEGIN,
        data
    }
}

const fetchReportSuccess = (data) => {
    return {
        type: AdminConstants.FETCH_REPORT_SUCCESS,
        data
    }
}

const fetchReportError = (error) => {
    return {
        type: AdminConstants.FETCH_REPORT_FAILURE,
        error
    }
}

export const getReport = (data) => (dispatch) => {
    dispatch(fetchReportBegin(data));
    API.getReport(data)
        .then((response) => {
            dispatch(fetchReportSuccess(response));
        })
        .catch((err) => {
            dispatch(fetchReportError(err));
        });
}
